if (!window.ys) {
  window.ys = {};
}

jQuery(document).ready(function ($) {
  // Smooth scroll to has tags
  $(document).on(
    'click',
    "a[href*='#']:not([href='#']):not(.prevent-scroll)",
    function (e) {
      if (
        location.pathname.replace(/^\//, '') ===
          this.pathname.replace(/^\//, '') &&
        location.hostname === this.hostname
      ) {
        var $el = $(this.hash);
        if ($el.length) {
          e.preventDefault();
          $('html,body').animate(
            {
              scrollTop: $el.offset().top,
            },
            500,
            'swing'
          );
        }
      }
    }
  );
  $('article.url-overriden.external a').each(function () {
    $(this).attr('target', '_blank');
  });
});

(function ($) {
  'use strict';

  // Initialize lazyload
  if (typeof this.WlcLazyload === 'function') {
    new this.WlcLazyload(document);
  }

  $(document).on('click', '.social-copy', function () {
    if (!$('#social-permalink').length) {
      return;
    }

    var clipboard = new WLCClipboard($('#social-permalink'));
    clipboard.copy();
    $('.social-copy-message').fadeIn(500, function () {
      $(this).delay(1000).fadeOut(1000);
    });
  });

  /*
   * General handler to toggle .expanded on click
   */
  $(document).on('click', '.toggle-click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    if ($(this).hasClass('expanded')) {
      $(this).removeClass('expanded');
      return;
    }
    if ($(this).hasClass('allow-single')) {
      $('.toggle-click.allow-single.expanded').removeClass('expanded');
    }
    $(this).addClass('expanded');
  });
  /*
   * Toggle annotation
   */
  $(document).on('click', '.annotation-button', function (e) {
    var $content = $(this).nextAll('.annotation-content');
    if ($content.is(':visible')) {
      $content.slideUp();
      return;
    }
    $content.slideDown();
  });

  document.addEventListener('YsAjaxLoader.afterShowContent', function (event) {
    var $content = event.detail.jQuery;

    $(document).trigger('LazyLoad:reload');

    var $imgs = $content.find('img');
    var imgCount = $imgs.length;
    if (imgCount) {
      $imgs.on('load', function () {
        imgCount--;
        if (imgCount === 0) {
          $content.stretchImages();
        }
      });
    }
  });

  $(window).on('load', function () {
    if (typeof ImageStretch === 'function') {
      // Initialize the image watcher - This class is responsible for watching images inside the defined
      // selectors and then stretching them to the full size of the container
      // The window is being watched for resize events rerun to fit the new container size
      new ImageStretch({
        default: [
          {
            selector:
              '.article-list:not(.grid-articles) .grid-item article .entry-thumbnail a',
          },
          {
            selector: '.gallery-item a',
          },
          {
            selector: '.sidebar .newsletter-subscribe-widget header',
          },
          {
            selector: '.articles.default .image-holder',
          },
          {
            selector: '.promo-articles .image-holder',
          },
          {
            selector: '.latest-tv .image-holder',
          },
        ],
        watched: [
          {
            selector: '.promo-area .image-holder',
          },
          {
            selector: '.sidebar .newsletter-subscribe-widget header',
          },
          {
            selector: '.knowledge-test .question',
          },
          {
            selector:
              'body.single > .carousel .carousel-inner.container .entry-featured-image',
          },
          {
            selector:
              'body.page > .carousel .carousel-inner.container .entry-featured-image',
          },
          {
            selector: '.grid-articles .image-holder',
          },
          {
            selector: '.mailkit-subscribe header',
          },
          {
            selector: '.responsive-bg-img',
          },
          {
            selector: '.category-tile .wrapper',
          },
        ],
      });
    }
  });

  var $userActivity = $('#user-activity');
  if ($userActivity.length > 0 && WLCPopup) {
    $userActivity.on(
      'RegistrationFramework:Entry:Initialized',
      function (e, fw, $entry) {
        var $details = $entry.find('.detail');
        if ($details.length) {
          var popup = new WLCPopup($details.html(), 'icon_right_tick');
          $details.html('');
          popup.show().addClass('registration-framework');
        }
      }.bind(this)
    );
  }

  $(document).on(
    'click touchstart',
    '#data-store-permission-popup .info',
    function () {
      var popup = $(this).data('popup');
      if (!popup) {
        var $content = $('<div>');
        var $header = $('<h2>').html($(this).parent().find('.text').text());
        $content.append($header);
        $content.append($(this).next('.description').html());

        popup = new WLCPopup($content.html());
        $(this).data('popup', popup);
      }

      popup.show();
    }
  );
}).bind(window)(jQuery);

// Yop Poll fix?

(function ($) {
  $(document).on('click', '.yop_poll_vote_button', function (e) {
    e.preventDefault();
  });
})(jQuery);
